import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { useLocation, useRouteLoaderData } from 'react-router-dom'

import { abstractReviewListEventsLoader, abstractSubmitListEventsLoader } from './Abstracts.loader'
import { LoaderData } from '../../types'

export default function EmptySelection() {
  const { t } = useTranslation('abstracts')
  const { pathname } = useLocation()

  const events = useRouteLoaderData(
    pathname.includes('/evaluation') ? 'review-abstracts-list' : 'submit-abstracts-list'
  ) as LoaderData<
    ReturnType<typeof abstractReviewListEventsLoader | typeof abstractSubmitListEventsLoader>
  >

  return (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
      <Typography variant="h3">
        {!!events?.length
          ? t('Veuillez sélectionner un événement dans la liste') + '.'
          : t('Aucun événement disponible pour le moment') + '.'}
      </Typography>
    </Box>
  )
}
